import { Card } from "../../models/card";
export class BlueGem extends Card {
}
BlueGem.displayName = "Blue Gem";
BlueGem.artUrl = "./assets/cards/bluegem.jpg";
